import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, Link } from "react-router-dom";

import { getPatientVisits } from "../../api";
import { Calendar, dateFnsLocalizer } from "react-big-calendar";
import { format, parse, startOfWeek, getDay } from "date-fns";

import { useAppContext } from "./../../AppContext";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendar,
  faCalendarDays,
  faCalendarCheck,
  faCalendarPlus,
  faUserDoctor,
  faHospital,
  faVideo,
  faPerson,
  faEye,
  faCross,
  faCancel
} from "@fortawesome/free-solid-svg-icons";

import CONFIG from './../../config';
import moment from "moment";

const locales = { "en-US": require("date-fns/locale/en-US") };
const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales,
});




function PatientVisitQueuePage({ onLogout }) {


  const navigate = useNavigate();
  const [selectedFilter, setSelectedFilter] = useState(null);
  const [viewMode, setViewMode] = useState("list"); // NEW toggle
  const [calendarView, setCalendarView] = useState("week"); // NEW calendar view


  const { state } = useAppContext();




  useEffect(() => {

    const loadAppointments = async () => {
      try {
        const patient_visits = await getAppointments();
        setSelectedFilter([...patient_visits]);
      } catch (err) {
        console.error(err);
      }
    };

    loadAppointments();
  }, [state?.patientId]);


  async function getAppointments() {
    // const el = document.getElementById("appt-list");
    // el.innerHTML = `<p style="color:#718096;text-align:center;padding:20px;">Loading…</p>`;
    try {
      const pid = state?.patientId;
      //if (!pid) { el.innerHTML = renderEmpty("Could not load patient record. Check 🔧 Debug tab."); return; }
      const r = await invokeLambda(CONFIG.lambdaAppointment, { action: "list", patient_id: pid });
      const appts = r && r.appointments ? r.appointments : [];
      //if (!appts.length) { el.innerHTML = renderEmpty("No upcoming appointments. Book one via ➕."); return; }
      //el.innerHTML = appts.map(renderCard).join("");
      return appts;
    } catch (err) {
      // el.innerHTML = `<div class="alert alert-error show">Failed: ${err.message}</div>`;
      return [];
    }
  }


  async function invokeLambda(fn, payload) {
    const url = `https://lambda.${CONFIG.region}.amazonaws.com/2015-03-31/functions/${fn}/invocations`;
    const body = JSON.stringify(payload);

    const headers = await signRequest("POST", url, body);
    const res = await fetch(url, { method: "POST", headers, body });
    const text = await res.text();
    let result; try { result = JSON.parse(text); } catch { result = text; }
    if (res.status !== 200) {
      console.log(`✗ Lambda HTTP ${res.status}`, result);
      throw new Error(`HTTP ${res.status}: ${text.slice(0, 200)}`);
    }
    if (result && result.errorMessage) {
      console.log(`✗ Lambda function error`, result);
      throw new Error(result.errorMessage);
    }

    return result;
  }

  async function signRequest(method, url, body) {
    const c = state.awsCreds;
    const p = new URL(url);
    const now = new Date();
    const dt = now.toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";
    const ds = dt.slice(0, 8);
    const ph = await sha256hex(body);
    const ch = `content-type:application/json\nhost:${p.host}\nx-amz-date:${dt}\nx-amz-security-token:${c.sessionToken}\n`;
    const sh = "content-type;host;x-amz-date;x-amz-security-token";
    const cr = [method, p.pathname, "", ch, sh, ph].join("\n");
    const sc = `${ds}/us-east-1/lambda/aws4_request`;
    const ss = ["AWS4-HMAC-SHA256", dt, sc, await sha256hex(cr)].join("\n");
    let sk = await hmac("AWS4" + c.secretAccessKey, ds);
    sk = await hmac(sk, "us-east-1"); sk = await hmac(sk, "lambda"); sk = await hmac(sk, "aws4_request");
    const sig = Array.from(new Uint8Array(await hmac(sk, ss))).map(b => b.toString(16).padStart(2, "0")).join("");
    return {
      "Content-Type": "application/json", "X-Amz-Date": dt, "X-Amz-Security-Token": c.sessionToken,
      "Authorization": `AWS4-HMAC-SHA256 Credential=${c.accessKeyId}/${sc}, SignedHeaders=${sh}, Signature=${sig}`
    };
  }

  async function hmac(key, msg) {
    const k = typeof key === "string" ? new TextEncoder().encode(key) : key;
    const ck = await crypto.subtle.importKey("raw", k, { name: "HMAC", hash: "SHA-256" }, false, ["sign"]);
    return new Uint8Array(await crypto.subtle.sign("HMAC", ck, new TextEncoder().encode(msg)));
  }

  async function sha256hex(msg) {
    const h = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(msg));
    return Array.from(new Uint8Array(h)).map(b => b.toString(16).padStart(2, "0")).join("");
  }


  //  async function getAppointments() {

  //   let url = CONFIG.apiEndpoint + '/patient/appointments';

  //   //url += `/${encodeURIComponent(state?.providerId)}`;

  //   const response = await fetch(
  //     url,
  //     {
  //       method: 'GET',
  //       headers: {
  //         'Authorization': `Bearer ${state?.accessToken}`,
  //         'Content-Type': 'application/json',
  //       },
  //     }
  //   );

  //   if (!response.ok) {
  //     throw new Error(`Request failed: ${response.status} ${response.statusText}`);
  //   }

  //   return response.json();
  // };

  const navReviewpage = (appointmentObj) => {
    navigate("/patient-review", {
      state: {
        appointment: appointmentObj,
      },
    })
  }

  const handleTabChange = (tab) => {
    console.log("Selected tab:", tab);

    if (tab === "visits") {
      // Load visits

      navigate('/doctor-dashboard');
    }

    if (tab === "conference") {
      // Load conference
      navigate('/doctor-vqueue');
    }
  };

  async function doCancelAppointment(visit) {
    console.log(visit);
    try {
      const apptId = visit.appointment_id;
      await invokeLambda(CONFIG.lambdaAppointment, { action: "cancel", patient_id: state.patientId, appointment_id: apptId, reason: "Cancelled via web portal" });
      const patient_visits = await getAppointments();
      setSelectedFilter([...patient_visits]);
    } catch (err) { alert("Cancel failed: " + err.message); }
  }




  return (<div className='container' >
    <div style={{ marginTop: '0px', paddingTop: '0px' }} >
      {/* <DashboardTabs onTabChange={handleTabChange} name={'visits'} /> */}



      <div className="">

        <div>
          <h3 className="queue-title my-4">
            Visits{" "}
            <span className="text-small">({selectedFilter?.length})</span>
          </h3>
        </div>

        <div className="queue-list" style={{ height: '600px', maxHeight: '600px' }} >
          {selectedFilter?.map((visit) => (
            <div
              className="queue-item"
              key={`${visit.id}`}
            >
              <div>
                <div className="visit-meta">
                  <div className="fw-bold fs-6 mb-2">
                    {visit.provider_name || "Not Available"}
                  </div>

                  <div className="d-flex flex-column flex-md-row gap-3">
                    <div>
                      <FontAwesomeIcon
                        icon={faCalendarDays}
                        className="me-2 text-primary"
                      />
                      Start Date:{" "}
                      {visit.created_at
                        ? moment(visit.created_at).format("MM-DD-YYYY HH:mm")
                        : ""}
                    </div>

                    <div>
                      <FontAwesomeIcon
                        icon={faUserDoctor}
                        className="me-2 text-primary"
                      />
                      {visit.provider_name || "Not Available"}
                    </div>

                    <div>
                      <FontAwesomeIcon
                        icon={faHospital}
                        className="me-2 text-primary"
                      />
                      {visit.reason_for_visit || "Not Available"}
                    </div>

                    <div>
                      {visit.visit_type?.toLowerCase() === "in-person" ? (
                        <span>
                          <FontAwesomeIcon icon={faPerson} className="mx-2 text-primary" />{visit.visit_type?.toLowerCase()}</span>
                      ) : (<span>
                        <FontAwesomeIcon icon={faVideo} className="mx-2 text-primary" />
                        {visit.visit_type?.toLowerCase()}
                      </span>
                      )}
                    </div>
                  </div>
                </div>

              </div>
              <div className="queue-item-status">
                <span
                  className={`wf-badge ${visit.appointment_status === "BOOKED" ? "pending" : "approved"}`}
                >
                  {visit.appointment_status}
                </span>
                <button
                  className="btn btn-sm btn-outline-danger"
                  onClick={() => doCancelAppointment(visit)}
                >
                  <FontAwesomeIcon icon={faCancel} className="text-danger" />
                  Cancel
                </button>
                <button
                  className="btn btn-sm btn-outline-success"
                  onClick={() => navReviewpage(visit)}
                >
                  <FontAwesomeIcon icon={faEye} className="text-success" />
                  Review
                </button>
              </div>
            </div>
          ))}
        </div>

      </div>



    </div></div>
  );
}

export default PatientVisitQueuePage;
